import React, { createContext, useContext } from 'react';
import { dict, formatEuro, type Dict, type Lang } from './i18n';

// Language context for V2.5 – FlowShort sets it from its `lang` prop.

const LangContext = createContext<Lang>('de');

export function LangProvider({ lang, children }: { lang: Lang; children: React.ReactNode }) {
  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export function useLang(): Lang {
  return useContext(LangContext);
}

/** Texts of the current language. */
export function useT(): Dict {
  return dict[useContext(LangContext)];
}

/** Euro formatter for the current language. */
export function useEuro() {
  const lang = useContext(LangContext);
  return (value: number) => formatEuro(value, lang);
}

/** Renders `**bold**` segments of a dictionary string as <strong>. */
export function Rich({ text, strongClassName = 'font-bold' }: { text: string; strongClassName?: string }) {
  return (
    <>
      {text.split('**').map((part, i) =>
        i % 2 ? (
          <strong key={i} className={strongClassName}>
            {part}
          </strong>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      )}
    </>
  );
}
